import {
    BotConvoStartedAction,
    RealConvoStartedAction,
    TypingStatusChangeAction,
    ConvoDetailsFetchedAction,
} from '../typedefs/actions';
import { ConversationState, SettingsState, VisitorState } from '../typedefs/store';
import { put, select, call, take, fork, takeEvery } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import {
    BOT_CONVO_STARTED,
    TYPING_STATUS_CHANGE,
    CONVO_DETAILS_FETCHED,
    CONVO_RESUMED,
} from '../typedefs/actionTypes';
import * as Pusher from 'pusher-js';
import { getSettings } from '../selectors/settings';
import { getConvo, getVisitor } from '../selectors/conversation';

let client: any;
let subscription: any | void;

export function clearSubscription() {
    subscription = null;
}

function connectToPusher(key: string, authEndpoint: string, token: string) {
    return new Promise((resolve, reject) => {
        client = new Pusher(key, {
            encrypted: true,
            authEndpoint,
            auth: {
                headers: {
                    'X-Visitor-Token': token,
                },
            },
        });

        client.connection.bind('connected', resolve);
    });
}

function* connectAndSubscribe() {
    const settings: SettingsState = yield select(getSettings);
    const convo: ConversationState = yield select(getConvo);
    const visitor: VisitorState = yield select(getVisitor);

    yield call(
        connectToPusher,
        settings.pusherKey,
        settings.inlineConfig.apiUrl + '/pusher/auth/visitor',
        visitor.visitorToken,
    );
    subscription = client.subscribe(convo.channel);
    yield fork(watchPusherChannel, subscription);
}

export function* watchPusherChannel(subscription: Pusher.Channel) {
    const whitelistedEvents = [
        'new-bot-message',
        'new-message',
        'started-real-convo',
        'agent-accepted',
        'conversation-ended',
        'bot-conversation-ended',
        'client-chat-status-notification',
        'client-video-request',
        'send-external-event',
        'redirect-to-url',
        'contact-info-gathered',
        'sent-to-crm',
    ];
    const chan = eventChannel(emitter => {
        whitelistedEvents.forEach(event => {
            subscription.bind(event, (data: any) => emitter({ event, data }));
        });

        return () => {
            whitelistedEvents.forEach(event => {
                subscription.unbind(event);
            });
        };
    });
    while (true) {
        const { event, data } = yield take(chan);
        yield put({
            type: 'SOCKET_EVENT_' + event.toUpperCase().replace(/[\W_]+/g, '_'),
            payload: { channel: subscription.name, ...data },
        });
    }
}

export function getSubscription() {
    return subscription;
}

function* typingStatusChange(action: TypingStatusChangeAction) {
    const visitor: VisitorState = yield select(getVisitor);
    if (!visitor.hasConvo || !subscription) return;

    subscription.trigger('client-chat-status-notification', {
        status: action.payload.status,
        fromType: 'visitor',
        fromId: visitor.visitorId,
    });
}

export default function* websocketSaga() {
    yield takeEvery([BOT_CONVO_STARTED, CONVO_RESUMED], connectAndSubscribe);
    yield takeEvery(TYPING_STATUS_CHANGE, typingStatusChange);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/websocketSaga.ts